/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles/index';
import T from 'i18n-react';
import PropTypes from 'prop-types';
import { validEmail, getCookie, setLanguageLocale } from 'util/icwUtility';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { ItemGrid } from 'components';
import cx from 'classnames';
// eslint-disable-next-line import/extensions
import loginStyles from 'assets/jss/icw/loginStyle.jsx';
import icwLogo from 'assets/img/qmas_logo_login.png';
import { LOGIN_LANG_PATH } from 'shared/path';
import { Checkmark } from 'react-checkmark';

setLanguageLocale(T, [LOGIN_LANG_PATH]);

const ResetPassword = (props) => {
  const { match, onInit, onResetPassword, classes, status, email } = props;
  const [emailField, setEmailField] = useState(email || '');
  const [error, setError] = useState(false);
  const [locale, setLocale] = useState('');
  const handleChange = (event) => {
    setEmailField(event.target.value);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    if (!validEmail(emailField)) {
      setError(true);
    } else {
      setError(false);
      onResetPassword(emailField, locale);
    }
  };
  useEffect(() => {
    const localeData = match.params.locale != null ? match.params.locale : getCookie('locale');
    setLocale(localeData);

    onInit();

    // eslint-disable-next-line
  }, []);

  return (
    <div className={classes.login}>
      <div
        className={cx(classes.notice, {
          [classes.showNotice]: error || status === 'failed',
        })}>
        {T.translate('login.invalidEmail')}
      </div>
      <div className={cx(classes.notice, { [classes.showNotice]: status === 'resent' })}>
        {T.translate('login.resentEmailMessage')}
      </div>
      <Grid container align='center' direction='column' spacing={0} className={classes.container}>
        <ItemGrid xs={12}>
          <a href='/'>
            <img className={classes.icon} src={icwLogo} alt='logo' />
          </a>
        </ItemGrid>
        {
          (status === 'resent') ? (
            <ItemGrid xs={12}>
              <div style={{ marginTop: 60 }}>
                <Checkmark size="xLarge" color="#223344" />
                <h2>Email Send!</h2>
                <div className={classes.receiveCode}>
                  {T.translate('login.didReceiveYourCodeMsg')}{' '}
                  <Link
                    className={classes.receiveCodeLink}
                    to={`/${locale}/reset-password`}
                    onClick={onSubmit}>
                    {T.translate('login.getNewEmail')}
                  </Link>
                </div>
              </div>
            </ItemGrid>
          ) : (
            <ItemGrid xs={12}>
              <div className={classes.loginContainer}>
                <h3 className={classes.title}>{T.translate('login.resetPassword')}</h3>
                <TextField
                  id='email-field'
                  label={T.translate('general.email')}
                  type='email'
                  value={emailField}
                  onChange={handleChange}
                  margin='normal'
                  className={classes.textField}
                />
                <div className={classes.btnBlock}>
                  <Button
                    onClick={onSubmit}
                    color='primary'
                    className={classes.button}
                    autoFocus
                    fullWidth>
                    {T.translate('login.resetMyPassword')}
                  </Button>
                </div>
              </div>
            </ItemGrid>
          )
        }
      </Grid>
    </div>
  );
};

ResetPassword.defaultProps = {
  status: '',
  email: '',
};

ResetPassword.propTypes = {
  email: PropTypes.string,
  onResetPassword: PropTypes.func.isRequired,
  onInit: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  status: PropTypes.string,
};

export default withStyles(loginStyles)(ResetPassword);
